const Earnings = () => {
    return <div id="Earnings" className="card">
        <h2>Earnings</h2>
        <h3>$1,300.42</h3>
        <button>Cash out</button>
    </div>
}

export default Earnings;